export const STORAGE_KEYS = {
  refreshToken: 'maefwk10:refresh',
  fingerprint: 'maefwk10:fp',
  colorScheme: 'maefwk10:color-scheme',
  lang: 'maefwk10:lang',
  tenantId: 'maefwk10:tenant',
  /** Tenant target del cross-tenant header (override volatile, sessionStorage). */
  activeTenantOverride: 'maefwk10:active-tenant',
  /** Nome leggibile del tenant override, per UI banner senza fetch aggiuntiva. */
  activeTenantOverrideName: 'maefwk10:active-tenant-name',
} as const;

export const JSON_API_CONTENT_TYPE = 'application/vnd.api+json';

export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;

export const PLATFORMS = ['web', 'ios', 'android'] as const;
export type Platform = (typeof PLATFORMS)[number];
